/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import "react-dropzone-uploader/dist/styles.css";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useTable,
} from "react-table";
import "./filtering.css";

import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { axiosInstance } from "../../../../services/AxiosInstance";

export const ColumnFilter = ({ column }) => {
  const { filterValue, setFilter } = column;
  return (
    <div>
      <input
        className="form-control input-search"
        value={filterValue || ""}
        onChange={(e) => setFilter(e.target.value)}
      />
    </div>
  );
};

export const GlobalFilter = ({ filter, setFilter }) => {
  return (
    <div>
      Search :{" "}
      <input
        type="search"
        className="ml-2 input-search form-control"
        value={filter || ""}
        onChange={(e) => setFilter(e.target.value)}
        style={{ width: "20%" }}
      />
    </div>
  );
};

export const Vendor = () => {
  const keys = ["id", "name"];
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [pagination,] = useState(null);
  const [selectpage, setselectpage] = useState(1);
  const onShow = () => setShow(true);
  const onHide = () => setShow(false);
  const [editshow, setEditShow] = useState(false);
  const onEditShow = () => setEditShow(true);
  const onEditHide = () => setEditShow(false);
  const [loader, setLoader] = useState(false);
  const [fieldvalue, setFieldValue] = useState();

  const COLUMNS = [
    ...keys.map((key) => ({
      Header: key.replace(/_/g, " "),
      Footer: key.replace(/_/g, " "),
      accessor: key,
      Filter: ColumnFilter,
    })),
    {
      Header: "Action",
      Footer: "Action",
      Cell: ({ row }) => {
        const DeleteVendor = (id) => {
          setLoader(true);
          try {
            axiosInstance
              .delete(`admin/del/vendor/${id}`)
              .then((response) => {
                if (response.data.status === true) {
                  getVendor();
                  toast.success(response.data.message);
                  setLoader(false);
                } else {
                  toast.error("SomeThing went Wrong");
                  setLoader(false);
                }
              })
              .catch((errors) => {
                toast.error("SomeThing went Wrong");
                setLoader(false);
              });
          } catch (error) {
            toast.error(error);
          }
        };
        return (
          <>
            <div className="d-flex gap-2">
              <button
                onClick={() => {
                  getVendorID(row.original.id);
                }}
                title="Edit"
                className={`btn btn-outline-success btn-sm rounded`}
              >
                <i className="fa fa-pen" />
              </button>
              <button
                onClick={() => {
                  DeleteVendor(row.original.id);
                }}
                title="Edit"
                className={`btn btn-outline-danger btn-sm rounded`}
              >
                <i className="fa fa-trash" />
              </button>
            </div>
          </>
        );
      },
    },
  ];

  const [columns] = useState(COLUMNS);
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,

    setGlobalFilter,
  } = tableInstance;
  const { globalFilter } = state;

  const getVendor = () => {
    setLoader(true);
    axiosInstance
      .get(`admin/get/all/vendors`)
      .then(function (response) {
        console.log(response, "Getting Companies");
        if (response?.data.status === true) {
          setData(response?.data?.data);
          console.log(response);
          setLoader(false);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          setLoader(false);
        }
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error, "song Error");
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
  };

  const getVendorID = (id) => {
    setLoader(true);
    axiosInstance
      .get(`admin/get/vendor/${id}`)
      .then(function (response) {
        console.log(response);
        if (response?.data.status === true) {
          setFieldValue(response?.data?.data);
          setLoader(false);
          onEditShow();
        } else {
          setLoader(false);
        }
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error, "song Error");
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
  };
  const addVendor = () => {
    setLoader(true);
    var formdata = new FormData();
    for (const key in fieldvalue) {
      if (Object.hasOwnProperty.call(fieldvalue, key)) {
        formdata.append(key, fieldvalue[key]);
      }
    }
    axiosInstance
      .post(`admin/add/vendor`, formdata)
      .then((response) => {
        if (response.data.status) {
          getVendor();
          onHide();
          toast.success(response.data.message);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };
  const updateCoverage = (id) => {
    setLoader(true);
    var formdata = new FormData();
    for (const key in fieldvalue) {
      if (Object.hasOwnProperty.call(fieldvalue, key)) {
        formdata.append(key, fieldvalue[key]);
      }
    }

    axiosInstance
      .post(`admin/update/vendor/${id}`, formdata)
      .then((response) => {
        if (response.data.status) {
          getVendor();
          onEditHide();
          toast.success(response.data.message);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };

  useEffect(() => {
    getVendor();
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFieldValue({ ...fieldvalue, [name]: value });
  };

  return (
    <>
      {loader && <div className="loader" />}
      <div className="card">
        <div>
          <div className="card-header">
            <h4 className="card-title float-left">Vendors</h4>
            <button className="btn btn-primary float-end" onClick={onShow}>
              Add Vendor
            </button>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            <table
              {...getTableProps()}
              id="table-to-export" // Add the id attribute
              className="table display"
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                        {/* {column.canFilter ? column.render("Filter") : null} */}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()} className="">
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {" "}
                            {cell.render("Cell")}{" "}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between">
            <span>
              Page{" "}
              <strong>
                {pagination?.current_page} of {pagination?.last_page}
              </strong>
              {""}
            </span>
            <span className="table-index">
              Go to page :{" "}
              <input
                type="number"
                value={perPage}
                onChange={(e) => setPerPage(e.target.value)}
                className="ml-2"
              />
            </span>
          </div>
          <div className="text-center">
            <div className="filter-pagination  mt-3">
              <button
                className=" previous-button"
                disabled={selectpage === 1}
                onClick={() => setselectpage(1)}
              >
                {"<<"}
              </button>

              <button
                className="previous-button"
                disabled={selectpage === 1}
                onClick={() => setselectpage(selectpage - 1)}
              >
                Previous
              </button>
              <button
                className="next-button"
                onClick={() => setselectpage(selectpage + 1)}
              >
                Next
              </button>
              <button
                className=" next-button"
                onClick={() => setselectpage(pagination?.last_page)}
                disabled={selectpage === pagination?.last_page}
              >
                {">>"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Add Modal */}
      <Modal show={show} onHide={onHide} size="sm">
        <Modal.Header closeButton>Add Vendor</Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h5 className="text-capitalize">Vendor Name</h5>

                <input
                  type="text"
                  name="name"
                  className="form-control p-2"
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onHide}>
            Close
          </Button>
          <Button variant="success" onClick={addVendor}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Add Modal Close */}
      {/* Update Modal Start */}
      <Modal show={editshow} onHide={onEditHide} size="sm">
        <Modal.Header closeButton>Vendor Details</Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              {keys
                .filter((s) => s !== "id")
                .map((key, index) => (
                  <div className={`mb-3 col-12`}>
                    <h5 className="text-capitalize">
                      {key.replace(/_/g, " ")}
                    </h5>
                    <input
                      className="form-control"
                      value={fieldvalue?.[key]}
                      name={key}
                      onChange={handleInputChange}
                    />
                  </div>
                ))}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onEditHide}>
            Close
          </Button>
          <Button
            variant="success"
            onClick={() => updateCoverage(fieldvalue.id)}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Update Modal Close */}
    </>
  );
};
export default Vendor;
